export default "__VITE_ASSET__DMZOj1Ne__"